/**
 * 登录上报
 */
import common from './common'
import { REPORT_PARAMS, SDK_PRODUCT } from '@/config/dataMap'
import cookies from 'js-cookie'
import { useEasyCounter } from '@crab/veekd'
import getClientInstallTime from '@/utils/getClientInstallTime'

const vip_version = REPORT_PARAMS.vip_version
const REPORT_VERSION = REPORT_PARAMS.report_version
const show_from = REPORT_PARAMS.show_from
const main_from = REPORT_PARAMS.main_from
const svrid = REPORT_PARAMS.user_svrid
const product_id = SDK_PRODUCT.id || 0
const uuid = cookies.get('uuid') || ''
const tryno = cookies.get('tryno') || ''

const centerStayTimeKfmt = 'duba_jgpdf_newvip_center_staytime:7361 stay_time:int version:byte show_from:int vip_version:int show_if:byte show_page:byte show_fail_reason:string show_time:int product_id:int pay_from:int url:string'
const loginPageClickKfmt = 'duba_jgpdf_newvip_loginpage_click:7360 main_from:int page_click:byte show_time:string version:byte vip_version:int product_id:int current_uuid:string current_tryno:string current_svrid:string login_type:byte'
const loginPageShowKfmt = 'duba_jgpdf_newvip_loginpage_show:8583 main_from:int page_show:byte reason:string show_time:string version:byte vip_version:int product_id:int current_uuid:string current_tryno:string current_svrid:string login_type:short days:int staytime:int'
const loginPageResultKfmt = 'duba_jgpdf_newvip_loginpage_result:8458 main_from:int result:int reason:string login_type:int openid:string vip_status:byte show_time:string version:byte vip_version:int product_id:int current_uuid:string current_tryno:string current_svrid:string is_vip:byte days:int'
const ocpcReportKfmt = 'duba_jgpdf_sem_ocpc:8173 activation:string signin:string buy:string error:string product_id:string version:byte vip_version:int click:string'

/**
 * 登录流程状态
 * @description 对应埋点表 duba_jgpdf_newvip_loginpage_show 中的page_show 字段
 */
const LOGIN_PIPE_STATUS = {
  /** 登录框展示关闭 */
  LOGIN_PAGE_CLOSE: 0,
  /** 登录框展示成功 */
  LOGIN_PAGE_SHOW_SUCCESS: 1,
  /** 登录框展示失败 */
  LOGIN_PAGE_SHOW_FAIL: 2,
  /** 登录二维码展示成功 */
  LOGIN_QRCODE_SHOW_SUCCESS: 3,
  /** 登录二维码展示失败 */
  LOGIN_QRCODE_SHOW_FAIL: 4,
}

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    /** 会员中心停留时长统计 */
    reportCenterStayTimeKfmt (params) {
      const info = {
        stay_time: parseInt(
          (new Date().getTime() - performance.timing.fetchStart) / 1000
        ),
        show_from,
        show_if: 1,
        show_page: 0,
        show_fail_reason: '',
        show_time: 0,
        vip_version,
        version: REPORT_VERSION,
        product_id,
        pay_from: 0,
        url: location.href || ''
      }
      return common.REPORT.client_report_by_kfmt(centerStayTimeKfmt, common.API.replaceObj(info, params))
    },

    /** 登录页展示上报 */
    async reportLoginPageShow (params) {
      const info = {
        main_from,
        page_show: 1,
        reason: '',
        show_time: '',
        version: REPORT_VERSION,
        vip_version,
        product_id,
        current_uuid: uuid,
        current_tryno: tryno,
        current_svrid: svrid,
        login_type: 0,
        days: 0,
        staytime: 0,
      }

      try {
        const client = useEasyCounter()
        if (params?.page_show === LOGIN_PIPE_STATUS.LOGIN_PAGE_SHOW_SUCCESS || params.page_show === undefined) {
          client.count('pdfvip_login_page_show_success', 1, { tryno })
        } else if (params?.page_show === LOGIN_PIPE_STATUS.LOGIN_PAGE_SHOW_FAIL) {
          client.count('pdfvip_login_page_show_fail', 1, { tryno })
        } else if (params?.page_show === LOGIN_PIPE_STATUS.LOGIN_QRCODE_SHOW_SUCCESS) {
          client.count('pdfvip_login_qrcode_show_success', 1, { tryno })
        } else if (params?.page_show === LOGIN_PIPE_STATUS.LOGIN_QRCODE_SHOW_FAIL) {
          client.count('pdfvip_login_qrcode_show_fail', 1, { tryno })
        } else if (params?.page_show === LOGIN_PIPE_STATUS.LOGIN_PAGE_CLOSE) {
          client.gauge('pdfvip_login_page_stay_time', params.stay_time, { tryno })
        }

        // 获取staytime
        params.staytime = params.stay_time ? params.stay_time : 0
        const { install_days } = await getClientInstallTime()
        info.days = install_days
      } catch (err) {
        console.log('error reported on login page:', err)
      }
      return common.REPORT.client_report_by_kfmt(loginPageShowKfmt, common.API.replaceObj(info, params))
    },

    /** 登录页点击上报 */
    reportLoginPageClick (params) {
      const info = {
        main_from,
        version: REPORT_VERSION,
        vip_version,
        page_click: 0,
        show_time: '',
        product_id,
        current_uuid: uuid,
        current_tryno: tryno,
        current_svrid: svrid,
        login_type: 0
      }
      return common.REPORT.client_report_by_kfmt(loginPageClickKfmt, common.API.replaceObj(info, params))
    },

    /** 登录页结果上报 */
    async reportLoginPageResult (params) {
      const info = {
        main_from,
        result: 0,
        reason: '',
        login_type: 0,
        openid: '',
        vip_status: 0,
        show_time: '',
        version: REPORT_VERSION,
        vip_version,
        product_id,
        current_uuid: uuid,
        current_tryno: tryno,
        current_svrid: svrid,
        is_vip: 0,
        days: 0
      }
      try {
        const { install_days } = await getClientInstallTime()
        info.days = install_days
      } catch (err) {
        console.log('get install_day err ', err)
      }
      return common.REPORT.client_report_by_kfmt(loginPageResultKfmt, common.API.replaceObj(info, params))
    },

    /** ocpc结果上报 */
    reportOcpcResult ({ code, ret }) {
      const info = {
        main_from,
        activation: '0',
        signin: ret || '0',
        buy: '0',
        error: code || '0',
        click: '0',
        version: REPORT_VERSION,
        vip_version,
        product_id,
        current_uuid: uuid,
        current_tryno: tryno,
        current_svrid: svrid,
        is_vip: 0
      }
      return common.REPORT.client_report_by_kfmt(ocpcReportKfmt, common.API.replaceObj(info, { code, ret }))
    }

  }
}
